(() => {
  if (window.gblApprovedLoaded) return;
  window.gblApprovedLoaded = true;
  const findGoogle = () => document.querySelector('[id*="rocket_google_reviews_app_block"] [id*="grp-entangle--root"], [id*="grp-entangle--root"]');
  const sync = () => {
    const row = document.querySelector('[data-gbl-reviews]');
    if (!row) return;
    const google = findGoogle();
    const googleCount = google?.querySelector('a[href*="google.com/maps"]')?.textContent.match(/[\d,]+/);
    const label = row.querySelector('.gbl-review-count');
    if (googleCount && label) {
      const next = label.textContent.replace(/^[\d,]+/, Number(googleCount[0].replace(/,/g, '')).toLocaleString('en-IN'));
      if (label.textContent !== next) label.textContent = next;
    }
    const product = document.querySelector('#judgeme_product_reviews');
    const productLink = row.querySelector('[data-gbl-review-link="product"]');
    if (productLink && productLink.hidden === !!product) productLink.hidden = !product;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-gbl-review-link]');
    if (!link) return;
    const target = link.dataset.gblReviewLink === 'google' ? findGoogle() : document.getElementById('judgeme_product_reviews');
    if (!target) return;
    event.preventDefault();
    target.setAttribute('tabindex', '-1');
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
    target.focus({preventScroll:true});
    history.replaceState(null, '', '#' + target.id);
  });
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  });
  observer.observe(document.documentElement, {subtree:true, childList:true});
  sync();
})();

(() => {
 const gallery = document.querySelector('product-info[data-product-id="9424958685503"] media-gallery');
 if (gallery && new URL(location.href).searchParams.get('variant') === '49796009034047') {
  // Let the existing personalizer attach to the original full-size image first.
  const selectMulticolour = () => {
   if (!gallery.querySelector('.product__media-item .pplr_preview_wrapper')) return false;
   const slide = gallery.querySelector('[data-media-id$="gbl-multicolour"]');
   if (slide) gallery.setActiveMedia(slide.dataset.mediaId, false);
   return true;
  };
  if (!selectMulticolour()) {
   const ready = new MutationObserver(() => { if (selectMulticolour()) ready.disconnect(); });
   ready.observe(gallery, {childList:true,subtree:true});
  }
 }
});
(() => {
 const gallery = document.querySelector('product-info[data-product-id="9424958685503"] media-gallery');
 if (!gallery) return;
 const showPersonalizedSample = event => {
  if (!event.target.matches('.pplr_text, .pplr_monogram[type="file"]')) return;
  const slide = gallery.querySelector('.product__media-item .pplr_preview_wrapper')?.closest('.product__media-item') || gallery.querySelector('.product__media-item:not(.gbl-extra-media)');
  if (slide && !slide.classList.contains('is-active')) gallery.setActiveMedia(slide.dataset.mediaId, false);
 };
 gallery.closest('product-info').addEventListener('input', showPersonalizedSample, true);
 gallery.closest('product-info').addEventListener('change', showPersonalizedSample, true);
 const warm = () => {
  const items = [...gallery.querySelectorAll('.product__media-item')];
  const index = Math.max(0, items.findIndex(item => item.classList.contains('is-active')));
  [index, (index+1)%items.length, (index+2)%items.length, (index+items.length-1)%items.length].forEach(i => {
   items[i]?.querySelectorAll('img').forEach(img => {img.loading = 'eager'; if (i === index) img.fetchPriority = 'high';});
  });
 };
 warm();
 gallery.addEventListener('slideChanged', warm);
 gallery.addEventListener('pointerdown', warm, {passive:true});
 new MutationObserver(warm).observe(gallery.querySelector('.product__media-list'),{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
 const modal = document.getElementById('ProductModal-' + gallery.closest('product-info').dataset.section);
 if (!modal) return;
 const warmViewer = () => {
  if (!modal.hasAttribute('open')) return;
  const images = [...modal.querySelectorAll('.product-media-modal__content > img[data-media-id]')];
  const index = images.findIndex(img => img.classList.contains('active'));
  if (index < 0) return;
  [index, index + 1, index - 1].forEach(i => {
   const img = images[i];
   if (!img) return;
   img.loading = 'eager';
   img.fetchPriority = i === index ? 'high' : 'auto';
   if (img.decode) img.decode().catch(() => {});
  });
 };
 new MutationObserver(warmViewer).observe(modal, {subtree:true, childList:true, attributes:true, attributeFilter:['open','class']});
 warmViewer();
})();
